import React from "react";
import Header from "../../components/Header";
import TokenEarningModal from "./TokenEarningModal";
import IconStoreModal from "../Polls/components/IconStoreModal";
import Firebase from "../../firebasehelper";
import TokenCard from "./TokenCard";
import GamificationImage from "../../assets/media/gamification.jpg";
import TokenImage from "../../assets/media/pending_token.png";
import ApproveEarningModal from "../BrandTokenEarning/ApproveEarningModal";
import "./index.css";
import EditTokenEarningModal from "./EditTokenEarningModal";

class TokenEarning extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      brand: "",
      role: "",
      loading: false,
      icon: "",
      tokenEarnings: [],
      selectedTokenEarning: null,
      flag: true,
      page: "live",
    };
  }

  componentDidMount() {
    if (!this.props.location.state) {
      this.props.history.push("/");
    } else {
      const { brand, role, username } = this.props.location.state;
      this.setState({ username, role, brand, loading: true });
      Firebase.getAllTokenEarnings((tokenEarnings) => {
        this.setState({
          tokenEarnings: tokenEarnings,
          loading: false,
        });
      });
    }
  }

  selectImage = (icon) => {
    this.setState({
      icon,
    });
  };

  addClicked = () => {
    this.setState({
      icon: "",
    });
  };

  onAdd = async (tokenEarning) => {
    this.setState({
      icon: "",
    });

    let payload = tokenEarning;
    if (localStorage.getItem("umbrella")) {
      payload = { brand: this.state.brand.name, ...payload };
    }
    payload.approved = true;
    Firebase.addTokenEarning(payload);
  };

  onEdit = (id, tokenEarning) => {
    Firebase.editTokenEarning(id, tokenEarning);
  };

  onItemClicked = (selectedTokenEarning) => () => {
    console.log("selectedTokenEarning", selectedTokenEarning);
    this.setState({
      selectedTokenEarning,
      icon: selectedTokenEarning.icon,
    });
  };
  showPage = (page) => {
    this.setState({ page });
    for (var i = 1; i < 100; i++) window.clearInterval(i);
  };
  renderContent = () => {
    const { tokenEarnings, page } = this.state;
    return (
      <div className="token-earning-content">
        <div
          className="row-div"
          style={{ justifyContent: "flex-start", marginBottom: 20 }}
        >
          <button
            className="btn btn-green"
            type="button"
            data-toggle="modal"
            data-target="#token_earning_modal"
            onClick={this.addClicked}
          >
            Add Standard Task
          </button>
          <div className="row-div" style={{ justifyContent: "space-around" }}>
            <button
              className={`btn ${page === "live" ? "btn-yellow" : "btn-white"}`}
              onClick={() => this.showPage("live")}
            >
              Live Standard Tasks
            </button>
            <button
              className={`btn ${
                page === "pending" ? "btn-yellow" : "btn-white"
              }`}
              onClick={() => this.showPage("pending")}
            >
              Pending Brand Tasks
            </button>
          </div>
        </div>

        <div className="token-earning-items">
          <img
            src={GamificationImage}
            alt="gamification"
            className="gamification-img"
          />
          {tokenEarnings
            .filter((task) => {
              if (page === "live" && !task.pending && !task.brand) {
                return true;
              } else if (page === "pending" && task.pending) {
                return true;
              } else return false;
            })
            .map((item, index) => {
              return (
                <TokenCard
                  key={index}
                  item={item}
                  onItemClicked={this.onItemClicked(item)}
                />
              );
            })}
        </div>
      </div>
    );
  };
  onApprove = async (tokenEarning, task_img) => {
    const { id } = this.state.selectedTokenEarning;
    tokenEarning.pending = false;
    this.setState({ loading: true });
    const { title } = tokenEarning;
    let img_url = "";
    if (task_img)
      img_url = await Firebase.uploadImage(task_img, title, "task_image");
    if (img_url) tokenEarning.img_url = img_url;
    Firebase.editTokenEarning(id, tokenEarning);
    this.setState({ loading: false });
  };
  render() {
    const { username, role, loading, icon, selectedTokenEarning } = this.state;
    return (
      <div id="page-container" className="token-earning-container">
        <Header username={username} role={role} />
        <main id="main-container">
          {loading && (
            <div className="loading">
              <i className="fa fa-4x fa-sync fa-spin text-muted" />
            </div>
          )}
          {!loading && this.renderContent()}
          <TokenEarningModal icon={icon} onAdd={this.onAdd} />
          <EditTokenEarningModal
            id={selectedTokenEarning ? selectedTokenEarning.id : ""}
            icon={icon}
            title={selectedTokenEarning ? selectedTokenEarning.title : ""}
            token={selectedTokenEarning ? selectedTokenEarning.token : 0}
            user_action={
              selectedTokenEarning ? selectedTokenEarning.action : ""
            }
            selectedPage={selectedTokenEarning ? selectedTokenEarning.page : ""}
            onSave={this.onEdit}
            media_type={
              selectedTokenEarning
                ? selectedTokenEarning.media_type
                : "image_file"
            }
            media_url={
              selectedTokenEarning ? selectedTokenEarning.media_url : null
            }
          />
          <ApproveEarningModal
            selectedTokenEarning={selectedTokenEarning}
            onApprove={this.onApprove}
          />
          <IconStoreModal selectImage={this.selectImage} disableBackdrop />
        </main>
      </div>
    );
  }
}

export default TokenEarning;



// WEBPACK FOOTER //
// ./src/screens/TokenEarning/index.js